import { StyleSheet } from 'aphrodite';
import { nameCircles, white } from '../../../styles/colors';

export const s = StyleSheet.create({
	root: {
		backgroundColor: white,
		borderRadius: 3,
		border: `1px solid ${nameCircles}`,
		boxShadow: '0 0 6px 0 rgba(139,139,139,0.20)',
		overflow: 'hidden',
		paddingLeft: 20,
		paddingRight: 20,
	},
	header: {
		width: '100%',
	},
});
